import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Modal from 'components/Modal';
import Loader from 'components/Loader';
import Button from 'components/Button';
import ButtonTypes from 'components/Button/Button.const';

import LogoIcon from 'components/svg/Logo';

import { injectStyles } from 'injectStyles';

import * as cssVariable from 'cssVariables';

import { GIGYA_SCREENSET_MOBILE_VIEW_BREAKPOINT } from 'globalConst/gigya-const';
import SyncScreen from './components/SyncScreen';
import InfoScreen from './components/InfoScreen';
import { SCREENS } from './TVConnectModal.const';
import { showTalpaGigyaModal } from 'actions/gigya-actions';
import { GIGYA_SCREENSET } from 'globalConst/gigya-const';
import { getStore } from 'store';

const store = getStore();
class TvConnectModal extends PureComponent {
  static propTypes = {
    user: PropTypes.object,
    onCloseModal: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
  };

  static defaultProps = {
    user: null,
  };

  state = {
    isConnected: false,
    isLoading: false,
    hasError: false,
  };

  setConnected = (isConnected) => {
    this.setState({ isConnected });
  };

  setLoading = (isLoading) => {
    this.setState({ isLoading });
  };

  setError = (hasError) => {
    this.setState({ hasError });
  };

  handleClose = () => {
    this.props.onCloseModal();
  };

  handleConnectClick = () =>
    this.state.isConnected ? this.setState({ hasError: false }) : this.setState({ hasError: true });

  handleLogin = () => {
    store.dispatch(showTalpaGigyaModal(GIGYA_SCREENSET.REGISTRATION_LOGIN, GIGYA_SCREENSET.LOGIN_SCREEN));
  };

  handleRegister = () => {
    store.dispatch(showTalpaGigyaModal(GIGYA_SCREENSET.REGISTRATION_LOGIN, GIGYA_SCREENSET.REGISTER_SCREEN, false));
  };

  renderScreens = () => {
    const { classes, user } = this.props;
    const { isConnected, isLoading, hasError } = this.state;
    const { isLoading: gigyaIsLoading, isLoggedIn } = user || {};
    const isGigyaMobileViewActive = window.innerWidth < GIGYA_SCREENSET_MOBILE_VIEW_BREAKPOINT;

    if (!isLoggedIn && isGigyaMobileViewActive && !gigyaIsLoading) {
      return (
        <Fragment>
          <InfoScreen image={SCREENS.info.image} title={SCREENS.info.title} text={SCREENS.info.text} />
          <div className={classNames(classes.buttonWrapper, classes.twoButtons)}>
            <Button
              className={classNames(classes.button, classes.buttonSecondary)}
              type={ButtonTypes.PRIMARY}
              onClick={this.handleLogin}
              text={SCREENS.info.loginLabel}
            />

            <Button
              className={classes.button}
              type={ButtonTypes.PRIMARY}
              onClick={this.handleRegister}
              text={SCREENS.info.registerLabel}
            />
          </div>
        </Fragment>
      );
    }

    if (isLoggedIn && !isConnected) {
      return (
        <Fragment>
          <SyncScreen
            isConnected={isConnected}
            isLoading={isLoading}
            setConnected={this.setConnected}
            setLoading={this.setLoading}
            setError={this.setError}
            hasError={hasError}
          />
          <div className={classes.buttonWrapper}>
            <Button
              className={classes.button}
              type={ButtonTypes.PRIMARY}
              onClick={this.handleConnectClick}
              text={isLoading ? SCREENS.sync.loadingLabel : SCREENS.sync.buttonLabel}
            />
            <p
              className={classNames(classes.message, {
                [classes.error]: hasError,
              })}
            >
              {SCREENS.sync.errorMessage}
            </p>
          </div>
        </Fragment>
      );
    }

    if (isLoggedIn && isConnected) {
      return (
        <Fragment>
          <InfoScreen image={SCREENS.success.image} title={SCREENS.success.title} />
          <Button
            className={classes.button}
            type={ButtonTypes.PRIMARY}
            onClick={this.handleClose}
            text={SCREENS.success.buttonLabel}
          />
        </Fragment>
      );
    }

    return (
      <div className={classes.loaderScreen}>
        <Loader />
      </div>
    );
  };

  render() {
    const { classes, user } = this.props;
    const { isLoading } = this.state;

    const { attemptingLogin } = user || {};

    // render after gigya login on desktop
    if (!attemptingLogin) {
      return (
        <Modal shouldRender dismissFunction={this.handleClose} standalone>
          <div className={classes.overlay} onClick={this.handleClose} role="presentation" />
          <div className={classes.modal}>
            <div
              className={classNames(classes.loader, {
                [classes.loaderActive]: isLoading,
              })}
            >
              <Loader />
            </div>
            <div className={classes.logo}>
              <LogoIcon />
            </div>
            <button
              className={classes.closeButton}
              type="button"
              onClick={this.handleClose}
              data-testid="close_show_more"
              disabled={isLoading}
            >
              {/* NOTE: close icon taken from talpaGigyaModal to match the design */}
              <img
                // eslint-disable-next-line max-len
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICAgIDxwYXRoIGZpbGw9IiMxYTFhMWEiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTExLjY5Ni4zMDRhMS4wNCAxLjA0IDAgMCAwLTEuNDcgMEw2IDQuNTMgMS43NzQuMzA0YTEuMDQgMS4wNCAwIDEgMC0xLjQ3IDEuNDdMNC41MyA2IC4zMDQgMTAuMjI2YTEuMDQgMS4wNCAwIDAgMCAxLjQ3IDEuNDdMNiA3LjQ3bDQuMjI2IDQuMjI2YTEuMDQgMS4wNCAwIDAgMCAxLjQ3LTEuNDdMNy40NyA2bDQuMjI2LTQuMjI2YTEuMDQgMS4wNCAwIDAgMCAwLTEuNDd6Ii8+Cjwvc3ZnPgo="
                alt="connect-tv-close-icon"
              />
            </button>

            {/* Handle screens */}
            {this.renderScreens()}
          </div>
        </Modal>
      );
    }
    return null;
  }
}

const styles = (theme) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    minWidth: '100vw',
    height: '100%',
    minHeight: '100vh',
    margin: 'auto',
    backgroundColor: cssVariable.transparentLightmode005,
    animation: '$fadeIn 600ms ease',
  },
  modal: {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    top: 'calc(50% - (650px / 2))',
    left: 'calc(50% - (100vw * .210526316 + 596.84210506px) / 2)',
    minWidth: 900,
    width: 'calc(100vw * 0.280898876 + 495.505617978px)',
    maxWidth: 1000,
    height: 'calc(100vh - 48px)',
    maxHeight: 650,
    backgroundColor: cssVariable.white,
    margin: 'auto',
    borderRadius: 4,
    padding: 35,
    boxSizing: 'border-box',
    animation: '$fadeIn 600ms ease',
  },
  loaderScreen: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loader: {
    display: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.8)',
  },
  loaderActive: {
    display: 'flex',
  },
  closeButton: {
    position: 'absolute',
    top: 15,
    right: 14,
    background: 'transparent',
    border: 'none',
    padding: 10,
  },
  logo: {
    width: 160,
  },
  message: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: -35,
    fontSize: cssVariable.fontSizes.xsmall,
    fontWeight: cssVariable.fontWeights.regular,
    textAlign: 'center',
    margin: '8px 0 10px 0',
    opacity: 0,
    visibility: 'hidden',
    transition: 'all .3s ease',
  },
  error: {
    color: cssVariable.red500,
    opacity: 1,
    visibility: 'visible',
  },
  buttonWrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    display: 'flex',
    width: '345px',
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: cssVariable.fontSizes.xsmall,
    fontWeight: cssVariable.fontWeights.bold,

    '&:hover': {
      transform: 'none',
    },
  },
  buttonSecondary: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: cssVariable.green500,
    color: cssVariable.green500,
    backgroundColor: 'transparent',

    '&:hover, &:focus': {
      color: cssVariable.green400,
      borderColor: cssVariable.green400,
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
  },
  '@keyframes fadeIn': {
    from: {
      opacity: '0',
    },
    to: {
      opacity: '1',
    },
  },
  [theme.breakpoints.down('ll')]: {
    modal: {
      width: 'calc(100vw * .210526316 + 596.84210506px)',
      minWidth: 800,
    },
    button: {
      width: '275px',
    },
  },
  [theme.breakpoints.down(GIGYA_SCREENSET_MOBILE_VIEW_BREAKPOINT)]: {
    overlay: {
      display: 'none',
    },
    modal: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      width: '100vw',
      minWidth: '100%',
      height: '100vh',
      maxHeight: '100%',
      padding: '35px 35px 15px 35px',
      overflow: 'scroll',
    },
    closeButton: {
      top: 6,
      right: 6,
    },
    message: {
      top: -35,
      bottom: 0,
    },
    twoButtons: {
      flexDirection: 'row',
      width: '100%',
      maxWidth: 320,
      justifyContent: 'space-around',

      '& > $button': {
        width: 'auto',
        minWidth: '45%',
      },
    },
  },
});

export default injectStyles(styles)(TvConnectModal);
